import axios, { AxiosInstance, AxiosError } from "axios";
import { useAuthStore } from "../stores/authStore";
import { SnackbarType, useSnackbarStore } from "../stores/useSnackbarStore";
import { REQUEST_WARNING_MESSAGES, REQUEST_WARNINGS_HEADER, RequestWarning } from "../interfaces/DTO/requestWarning";

// פונקציה לקריאת Cookie
const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(";").shift() || null;
  return null;
};

const apiClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8000/api",

 //  baseURL: process.env.REACT_APP_API_URL || '/api',
 
  withCredentials: true, // מאפשר שליחה של Cookies לשרת
});

// Interceptor להגדרת XSRF Token בכל בקשה
apiClient.interceptors.request.use(
  (config) => {
    const xsrfToken = getCookie("XSRF-TOKEN"); // שם ה-Cookie שהגדרת בשרת
    if (xsrfToken && config.headers) {
      config.headers["X-XSRF-TOKEN"] = xsrfToken; // הוספת הכותרת לבקשה
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// warnings of a request that succeeded (e.g. a family saved but its insights not recalculated) - see requestWarning.ts
const showRequestWarnings = (header: string | undefined) => {
  if (!header) return;
  const messages = header
    .split(",")
    .map((code) => REQUEST_WARNING_MESSAGES[code.trim() as RequestWarning])
    .filter(Boolean);
  if (messages.length) useSnackbarStore.getState().showSnackbar(messages.join(" "), SnackbarType.WARNING);
};

// Interceptor לטיפול ב-401
apiClient.interceptors.response.use(
  (response) => {
    showRequestWarnings(response.headers[REQUEST_WARNINGS_HEADER]);
    return response;
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      // אם זה URL ציבורי, לא עושים redirect ל-login
      const isPublicUrl = window.location.pathname.startsWith("/public");

      if (!isPublicUrl) {
        console.error("Unauthorized: Redirecting to login...");
        const setAuthenticated = useAuthStore.getState().setAuthenticated;
        setAuthenticated(false); // עדכון ה-Store

        // בדיקת מיקום נוכחי למניעת לולאת הפניה
        if (window.location.pathname !== "/login") {
          // שמירת הנתיב הנוכחי ב-returnUrl
          const currentPath = window.location.pathname + window.location.search;
          window.location.href = `/login?returnUrl=${encodeURIComponent(currentPath)}`;
        }
      }
    }
    if (error.response?.status === 403) {
      console.error("Forbidden: Access denied.");
      // ניתן להוסיף הפניה לעמוד ייעודי
    }

    return Promise.reject(error);
  }
);

export default apiClient;
